import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import store from "./store";
import { setUser } from "./store/actions/authAction";
import setAuthHeader from "./utils/setAuthHeader";
import { Provider } from "react-redux";

if (localStorage.accessInfo) {
  store.dispatch(setUser(JSON.parse(localStorage.accessInfo)));
  const response = JSON.parse(localStorage.accessInfo);
  setAuthHeader(response.token);
} else {
  store.dispatch(setUser({}));
  setAuthHeader(false);
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
